import { getCurrentShellBasePath } from "lib/routes/current-shell-path"

export function getLegislationResolutionsRootPath(topLevelPath) {
    return `${getCurrentShellBasePath(topLevelPath)}/schedule-resolutions`
}

export function getLegislationResolutionPath(id, topLevelPath) {
    return `${getLegislationResolutionsRootPath(topLevelPath)}/${encodeURIComponent(id)}`
}
